export default function ThongTinLai({ data, formatNumber }) {
  return (
    <div className="form-body form-bordered-2 row-store">
      <div className="row col-md-12 ">
        <div className="col-md-12">
          <div className="form-group last-1">
            <div className="row" style={{ padding: "20px" }}>
              <div className="col-md-6 color7-bold">Lãi chưa thu dự kiến</div>
              <div className="col-md-6 color-do-bold text-right">
                {formatNumber(Math.round(data.LaiChuaThuDuKien))}
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <div className="form-group last-1">
            <div className="row" style={{ padding: "20px" }}>
              <div className="col-md-6 color7-bold">Lãi đã thu</div>
              <div className="col-md-6 color-xanh-bold text-right">
                {formatNumber(Math.round(data.LaiDaThu))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
